module.exports = __webpack_public_path__ + "img/company-img-empty.dcb73ead.png";